export default function JiliScrollIcon({ onOpen }) {
	return (
		<div
			className="jili-quest-icon"
			onClick={onOpen}
			role="button"
			tabIndex={0}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					onOpen();
				}
			}}
		>
			<img src="/images/jili-quest/INFO_SCROLL.webp" alt="Jili Quest" />
		</div>
	);
}
